const ConfigParam = {
  btn_google_signin_dark_normal_web: 'https://d2atdwxjx7uc4i.cloudfront.net/images/google.svg',
  contFacebook: 'https://d2atdwxjx7uc4i.cloudfront.net/images/facebook.svg',
  twitter_button: 'https://d2atdwxjx7uc4i.cloudfront.net/images/x3.svg',
}
export default ConfigParam
